import { Button, Input } from "antd";
import {
    CheckCircleFilled
} from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ConnectCodeView() {
    const { t } = useTranslation();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);

    const toggleSelect = (id: string) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };

    return (
        <div className="flex-1 flex flex-col items-center text-center">

            <div className="w-28 h-28 bg-gray-100 rounded-full mb-6">
                <img src="https://pancake.vn/static/images/other-icon/connect-code.svg" style={{ height: '145px' }} alt="Connect Code" />
            </div>

            <h3 className="text-lg font-medium mb-3">
                {t('chats.add_page_code')}
            </h3>

            <Input
                placeholder="VD: 9kNED3RwMPVRIs7gIQSuDmIgbIL0Rhp"
                className="w-[360px] mb-4"
            />

            <Button type="primary" className="w-[360px] mb-3 w-[32px] h-[32px] p-0 flex items-center justify-center border bg-[#3e91ab] hover:!bg-[#357f96] hover:border-[#357f96]">
                {t('chats.add_page')}
            </Button>

            <div className="text-sm text-gray-500">
                {t('chats.code_hint')}
                <br />
                <span className="text-[#357f96] cursor-pointer hover:underline">
                    {t('chats.see_more')}
                </span>
            </div>
        </div>
    );
}